import {
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,
    USER_VERIFY_OTP_REQUEST,
    USER_VERIFY_OTP_SUCCESS,
    USER_VERIFY_OTP_FAIL,
    USER_CLEAR_ERROR,
} from '../constants/userConstants';

export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_REGISTER_REQUEST:
            return { loading: true };

        case USER_REGISTER_SUCCESS:
            return { loading: false, success: true, userInfo: action.payload };

        case USER_REGISTER_FAIL:
            return { loading: false, error: action.payload };

        case USER_CLEAR_ERROR:
            return { ...state, error: null };

        default:
            return state;
    }
};


export const userLoginReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return { loading: true };
        case USER_LOGIN_SUCCESS:
            return { loading: false, userInfo: action.payload };
        case USER_LOGIN_FAIL:
            return { loading: false, error: action.payload };

        case USER_CLEAR_ERROR:
            return { ...state, error: null };

        case USER_LOGOUT:
            return {};
        default:
            return state;
    }
};



export const userOtpVerifyReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_VERIFY_OTP_REQUEST:
            return { loading: true };
        case USER_VERIFY_OTP_SUCCESS:
            return { loading: false, userInfo: action.payload };
        case USER_VERIFY_OTP_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};